import React from "react";
import { STRINGS } from "../strings";
import { translate } from "../translate";
import { MEDFLYT_LOGO } from "../utils/svgs_new";
import { AppIcon } from "./Generic/AppIcon";

const MedFlytPassportLogo = () => {
  return (
    <div className="MedFlytPassportLogo">
      <AppIcon style={{ width: 130 }} size={32} icon={MEDFLYT_LOGO} />
      <span>{translate(STRINGS.PASSPORT)}</span>
    </div>
  );
};

export default MedFlytPassportLogo;
